import _ from "lodash"
import { BASE_URL } from "../../../api/EndPoints"
import { useNavigate } from "react-router-dom"

const ComboCartVariant = ({ items,uom }) => {
  const navigate = useNavigate();
  return (<div className="flex g-8 cart-item-padding p-b-8">
    <div className="compo-cart-product-layout">
      <div className="adaptive-layout boundary-width-768 flex-fill" style={{ gap: '16px' }}>
      </div>{items.variants.length > 0 ? <>{_.map(items.variants, (variant, index) => (<>
        <div className="flex g-8 cart-item-padding p-b-8">
          <div className="cart-product-layout">
            <div className="adaptive-layout boundary-width-768 flex-fill" style={{ gap: '16px' }}>
              <div className="adaptive-layout boundary-width-768 flex-fill g-40" style={{ gap: '0px' }}>
                <div className="flex-row items-start g-8">
                  <div className="wrapper-product-info">
                    <div className="image-container flex-wrap">
                      <div className="product-image-thumbnail center overlay">
                        <img
                          className="app-img cover"
                          src={`${BASE_URL}${variant.image?.replace("/api", "")}?time=${Date?.now()}`}
                          alt="ultronOn - No. 1 Wholesale fabric platform for Fashion Brands"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div className="lcn-container">
                      <div className="flex-row items-center">
                        <div className="ql-code">{items.combo.articleCode}</div>
                      </div>
                      <div className="pd-code">
                        <span className="clickable-area" onClick={() => {
                          if (items.combo.published === "true") {
                            navigate(`${items.combo.pimUrl}`)
                          }
                        }}>
                          {variant.variantSku}
                        </span>
                      </div>
                      {items.combo.published === "false" && <p style={{ color: "red" }}>(Product unavailable)</p>}

                      <div className="adaptive-label-color-number">
                        <span>#{variant.variants.filter(item => item.type === 'Colour')[0].value}</span>
                      </div>
                    </div>
                    <div>
                      <div style={{ display: 'flex',justifyContent:'space-between',gap:'5rem',marginLeft:'5rem' }}>
                        <div >{items.combo.quantity} {uom[items.combo.variants?.[0]?.variantSku]}</div>

                        <div>&#8377;{(items.combo.quantity * items.combo.sellingPrice).toFixed(2)}</div>
                        <div >&#8377;{(items?.combo.sellingPrice).toFixed(2)}/{uom[items.combo.variants?.[0]?.variantSku]}</div>

                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div></div></div>
      </>))}</> : <>
        <p style={{ color: "red" }}>(Combo unavailable)</p>
      </>}

    </div></div>)
}

export default ComboCartVariant